import api from '../../lib/api';

// Константы для действий
export const COHORT_RECALCULATION_HISTORY_LOAD = 'COHORT_RECALCULATION_HISTORY_LOAD';
export const COHORT_RECALCULATION_LOAD = 'COHORT_RECALCULATION_LOAD';
export const COHORT_RECALCULATION_ESTIMATE = 'COHORT_RECALCULATION_ESTIMATE';
export const COHORT_RECALCULATION_START = 'COHORT_RECALCULATION_START';
export const COHORT_RECALCULATION_CANCEL = 'COHORT_RECALCULATION_CANCEL';
export const COHORT_RECALCULATION_RESULTS_LOAD = 'COHORT_RECALCULATION_RESULTS_LOAD';
export const UPDATE_RECALCULATION_PROGRESS = 'UPDATE_RECALCULATION_PROGRESS';

// Константы для мутаций
const COHORT_RECALCULATION_HISTORY_LOADING_CHANGE = 'COHORT_RECALCULATION_HISTORY_LOADING_CHANGE';
const COHORT_RECALCULATION_HISTORY_CHANGE = 'COHORT_RECALCULATION_HISTORY_CHANGE';
const COHORT_RECALCULATION_LOADING_CHANGE = 'COHORT_RECALCULATION_LOADING_CHANGE';
const COHORT_RECALCULATION_CHANGE = 'COHORT_RECALCULATION_CHANGE';
const COHORT_RECALCULATION_ERRORS_CHANGE = 'COHORT_RECALCULATION_ERRORS_CHANGE';
const COHORT_RECALCULATION_ESTIMATING_CHANGE = 'COHORT_RECALCULATION_ESTIMATING_CHANGE';
const COHORT_RECALCULATION_ESTIMATION_CHANGE = 'COHORT_RECALCULATION_ESTIMATION_CHANGE';
const COHORT_RECALCULATION_STARTING_CHANGE = 'COHORT_RECALCULATION_STARTING_CHANGE';
const COHORT_RECALCULATION_CANCELLING_CHANGE = 'COHORT_RECALCULATION_CANCELLING_CHANGE';
const COHORT_RECALCULATION_RESULTS_LOADING_CHANGE = 'COHORT_RECALCULATION_RESULTS_LOADING_CHANGE';
const COHORT_RECALCULATION_RESULTS_CHANGE = 'COHORT_RECALCULATION_RESULTS_CHANGE';


const state = {
  // История операций пересчета
  recalculations_history: [],
  recalculations_history_total: 0,
  recalculations_history_per_page: 20,
  recalculations_history_page: 1,
  recalculations_history_loading: false,

  // Текущая операция для детального просмотра
  current_recalculation: null,
  current_recalculation_loading: false,
  current_recalculation_errors: {},

  // Оценка времени выполнения
  estimation_result: null,
  estimation_loading: false,

  // Состояния загрузки для операций
  starting_loading: false,
  cancelling_loading: false,

  // Результаты завершенной операции
  results: null,
  results_loading: false,

};

const actions = {
  /**
     * Загружает историю операций пересчета когорт
     */
  [COHORT_RECALCULATION_HISTORY_LOAD]({ commit, state }, { organization_id, params = {} }) {
    return api.list(
      'organization.cohorts.recalculation.history',
      organization_id,
      params,
      state,
      commit,
      COHORT_RECALCULATION_HISTORY_LOADING_CHANGE,
      COHORT_RECALCULATION_HISTORY_CHANGE,
    );
  },

  /**
     * Загружает детали конкретной операции пересчета
     */
  [COHORT_RECALCULATION_LOAD]({ commit, state }, { organization_id, recalculation_id }) {
    return api.load(
      'organization.cohorts.recalculation.status',
      [organization_id, recalculation_id],
      state,
      commit,
      COHORT_RECALCULATION_LOADING_CHANGE,
      COHORT_RECALCULATION_CHANGE,
      COHORT_RECALCULATION_ERRORS_CHANGE,
    );
  },

  /**
     * Оценивает время выполнения операции пересчета
     */
  [COHORT_RECALCULATION_ESTIMATE]({ commit, state }, { organization_id, data }) {
    return api.createWithData(
      'organization.cohorts.recalculation.estimate',
      organization_id,
      data,
      state,
      commit,
      COHORT_RECALCULATION_ESTIMATING_CHANGE,
      COHORT_RECALCULATION_ESTIMATION_CHANGE,
      COHORT_RECALCULATION_ERRORS_CHANGE,
    );
  },

  /**
     * Запускает операцию пересчета когорт
     */
  [COHORT_RECALCULATION_START]({ commit, state }, { organization_id, data }) {
    return api.createWithData(
      'organization.cohorts.recalculation.start',
      organization_id,
      data,
      state,
      commit,
      COHORT_RECALCULATION_STARTING_CHANGE,
      COHORT_RECALCULATION_CHANGE,
      COHORT_RECALCULATION_ERRORS_CHANGE,
    );
  },

  /**
     * Отменяет операцию пересчета
     */
  [COHORT_RECALCULATION_CANCEL]({ commit, state }, { organization_id, recalculation_id }) {
    commit(COHORT_RECALCULATION_CANCELLING_CHANGE, true);
    return api.delete(
      'organization.cohorts.recalculation.cancel',
      [organization_id, recalculation_id],
      state,
      commit,
      COHORT_RECALCULATION_CHANGE,
    ).finally(() => {
      commit(COHORT_RECALCULATION_CANCELLING_CHANGE, false);
    });
  },

  /**
     * Загружает результаты завершенной операции
     */
  [COHORT_RECALCULATION_RESULTS_LOAD]({ commit, state }, { organization_id, recalculation_id }) {
    return api.load(
      'organization.cohorts.recalculation.results',
      [organization_id, recalculation_id],
      state,
      commit,
      COHORT_RECALCULATION_RESULTS_LOADING_CHANGE,
      COHORT_RECALCULATION_RESULTS_CHANGE,
      COHORT_RECALCULATION_ERRORS_CHANGE,
    );
  },


  /**
     * Обновляет прогресс операции через WebSocket
     */
  [UPDATE_RECALCULATION_PROGRESS]({ commit }, { recalculationId, progressData }) {
    commit(UPDATE_RECALCULATION_PROGRESS, { recalculationId, progressData });
  },
};

const mutations = {
  // История операций
  [COHORT_RECALCULATION_HISTORY_LOADING_CHANGE](state, data) {
    state.recalculations_history_loading = data;
  },

  [COHORT_RECALCULATION_HISTORY_CHANGE](state, data) {
    if (data?.data) {
      state.recalculations_history = data.data;
      // API возвращает totalCount или total
      state.recalculations_history_total = data.totalCount || data.total || 0;
      // Вычисляем per_page и page на основе skip/take
      const take = data.take || 20;
      const skip = data.skip || 0;
      state.recalculations_history_per_page = take;
      state.recalculations_history_page = Math.floor(skip / take) + 1;
    } else {
      state.recalculations_history = [];
      state.recalculations_history_total = 0;
      state.recalculations_history_per_page = 20;
      state.recalculations_history_page = 1;
    }
  },

  // Текущая операция
  [COHORT_RECALCULATION_LOADING_CHANGE](state, data) {
    state.current_recalculation_loading = data;
  },

  [COHORT_RECALCULATION_CHANGE](state, data) {
    if (data?.data) {
      state.current_recalculation = data.data;
    } else {
      state.current_recalculation = null;
    }
  },

  [COHORT_RECALCULATION_ERRORS_CHANGE](state, data) {
    state.current_recalculation_errors = data;
  },

  // Оценка времени
  [COHORT_RECALCULATION_ESTIMATING_CHANGE](state, data) {
    state.estimation_loading = data;
  },

  [COHORT_RECALCULATION_ESTIMATION_CHANGE](state, data) {
    if (data?.data) {
      state.estimation_result = data.data;
    } else {
      state.estimation_result = null;
    }
  },

  // Состояния операций
  [COHORT_RECALCULATION_STARTING_CHANGE](state, data) {
    state.starting_loading = data;
  },

  [COHORT_RECALCULATION_CANCELLING_CHANGE](state, data) {
    state.cancelling_loading = data;
  },

  // Результаты
  [COHORT_RECALCULATION_RESULTS_LOADING_CHANGE](state, data) {
    state.results_loading = data;
  },

  [COHORT_RECALCULATION_RESULTS_CHANGE](state, data) {
    if (data?.data) {
      state.results = data.data;
    } else {
      state.results = null;
    }
  },

  // Обновление прогресса через WebSocket
  [UPDATE_RECALCULATION_PROGRESS](state, { recalculationId, progressData }) {
    if (
      state.current_recalculation && state.current_recalculation.recalculation_id === recalculationId
    ) {
      // Обновляем данные текущего пересчета
      state.current_recalculation.status = progressData.status;
      state.current_recalculation.progress_percentage = progressData.progress;
      state.current_recalculation.processed_orders = progressData.processedOrders || 0;
      state.current_recalculation.updated_orders = progressData.updatedOrders || 0;
      state.current_recalculation.chunks_completed = progressData.chunksCompleted || 0;
      state.current_recalculation.chunks_total = progressData.chunksTotal || 0;

      // Обновляем время завершения если есть
      if (progressData.estimatedCompletion) {
        state.current_recalculation.estimated_completion = progressData.estimatedCompletion;
      }

      // Обновляем время завершения если операция завершена
      if (['completed', 'failed', 'cancelled'].includes(progressData.status)) {
        state.current_recalculation.completed_at = new Date().toISOString();
      }
    }
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
